import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { selectGlobalDbnTaxonomySubDomainAttributesCreatedItem, selectGlobalDbnTaxonomySubDomainAttributesDeletedItem, selectGlobalDbnTaxonomySubDomainAttributesListItems, selectGlobalDbnTaxonomySubDomainAttributesUpdatedItem } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes/selector";
import { globalDbnTaxonomySubDomainAttributes } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes/action";
import PageLoader from "../../../../components/PageLoader";
import { settings } from "../../../../redux/settings/actions";
import UploadCommonModal from "../../../../models/upload-common-modal";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { toast } from "react-toastify";
import Table from "../../../../common/components/table-manager/v1.1/table";

const GlobalDbnTaxonomySubDomainAttributes = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const { getUploadModal } = useAppSelector(selectCurrent)
  const listGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesListItems)
  const createGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesCreatedItem)
  const updateGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesUpdatedItem)
  const deleteGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesDeletedItem)
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text', },
      { field: 'SubDomainName', headerName: 'Sub-Domain Name', searchField: 'SubDomainName', sortable: true, filter: true, filterType: 'text' },
      { field: 'AttributeValueSource.SourceType', headerName: 'Source Type', sortable: true, filter: true, filterType: 'text' },
      { field: 'AttributeValueSource.SourceTypeName', headerName: 'Source Type Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'AttributeValueSource.SourceAttributeName', headerName: 'Source Attribute Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'AttributeValueSource.ControlType', headerName: 'Control Type', sortable: true, filter: true, filterType: 'text' },
      { field: 'AttributeValueSource.IsAppliedForVariant', headerName: 'Applied For Variant', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'IsActive', headerName: 'Is Active', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDeleted', headerName: 'Is Deleted', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'IsPublished', headerName: 'Is Published', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
    ]);
  }

  const fetchGlobalDbnTaxonomySubDomainAttributes = async () => {
    await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomySubDomainAttributes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/dbn-fetch`, entity: 'GlobalDbnTaxonomySubDomainAttributes', jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data.DBNSubDomainAttributeId}`)
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomySubDomainAttributes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/dbn-fetch`,
      entity: 'globalDbnTaxonomySubDomainAttributes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "DBNSubDomainAttributeId",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleDownloadTemplate = () => {
    const fileUrl = require('../../../../assets/data/attribute_template.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "attribute_template.csv"); // Optional: Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const additionButtons: any = [
    // {
    //   name: 'Add Attribute',
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Import Attributes</title>
          <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Import Attributes',
      callback: () => handleImportAttributesClick(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
          <title>Download Template</title>
          <path d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Download',
      callback: () => handleDownloadTemplate(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchGlobalDbnTaxonomySubDomainAttributes();
  }

  const handleImportAttributesClick = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = async (data: any) => {
    await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'delete' }))
    await dispatch(globalDbnTaxonomySubDomainAttributes.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-domains/delete`,
      entity: 'globalDbnTaxonomySubDomainAttributes',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.DBNSubDomainAttributeId
          }
        ]
      }
    })).then(() => {
      fetchGlobalDbnTaxonomySubDomainAttributes();
    });
  }

  const handleImportClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    console.log('handleImportClick data', data)
    await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(globalDbnTaxonomySubDomainAttributes.uploadCreate({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/upload-dbn-sub-domain-attributes`,
      entity: 'createSubDomainAttributes',
      jsonData:
        frmData
    })).then(() => {
      handleUploadClose()
    }).then(() => {
      fetchGlobalDbnTaxonomySubDomainAttributes();
    })
  };

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }
  
  useEffect(() => {
    console.log('listGlobalDbnTaxonomySubDomainAttributesData', listGlobalDbnTaxonomySubDomainAttributesData)
    const searchCriteria: any = listGlobalDbnTaxonomySubDomainAttributesData?.result?.items
      ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
      ?.map((item: any) => ({
        FieldName: item.Message.SpecificationAttributeName,
      }));
    setSearchCriteriaList(searchCriteria)
  }, [listGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    console.log('createGlobalDbnTaxonomySubDomainAttributesData', createGlobalDbnTaxonomySubDomainAttributesData)
    if (createGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'create' }))
      toast.info('Domain created successfully.')
    }
  }, [createGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    console.log('updateSettlementRequestsData', updateGlobalDbnTaxonomySubDomainAttributesData)
    if (updateGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'update' }))
      toast.info('Domain updated successfully.')
    }
  }, [updateGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    console.log('deleteSettlementsRequestsData', deleteGlobalDbnTaxonomySubDomainAttributesData)
    if (deleteGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'delete' }))
      toast.info('Domain deleted successfully.')
    }
  }, [deleteGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    createColumnDefs()
    fetchGlobalDbnTaxonomySubDomainAttributes()
    dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'create' }))
    dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'uploadCreate' }))
    dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'update' }))
    dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'delete' }))
  }, [pageData, pageSize])

  return (
    <>
      {getUploadModal == 'open' && <UploadCommonModal title='Import Attributes' onSubmit={handleImportClick} handleClose={handleUploadClose} />}
      {listGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        createGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        updateGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        deleteGlobalDbnTaxonomySubDomainAttributesData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={listGlobalDbnTaxonomySubDomainAttributesData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listGlobalDbnTaxonomySubDomainAttributesData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Global DBN Taxonomy Sub-Domain Attributes"
        />
      }
    </>
  );
};

export default GlobalDbnTaxonomySubDomainAttributes;


